import React, { useCallback, useEffect, useState } from "react";
import { Alert, Badge, Button, Card, ListGroup, Spinner } from "react-bootstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const NotificationInbox = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const fetchNotifications = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API_URL}/notifications`, {
        params: showUnreadOnly ? { unread: 1 } : {},
      });
      setItems(res.data || []);
    } catch (err) {
      setError("Không thể tải thông báo.");
    } finally {
      setLoading(false);
    }
  }, [showUnreadOnly]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const markRead = async (id) => {
    await axios.put(`${API_URL}/notifications/${id}/read`);
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, read_at: item.read_at || new Date().toISOString() } : item,
      ),
    );
  };

  const markAllRead = async () => {
    await axios.put(`${API_URL}/notifications/read-all`);
    await fetchNotifications();
  };

  return (
    <div className="notification-inbox">
      <div className="admin-page-intro">
        <div>
          <span>Thông báo</span>
          <h2>Inbox</h2>
          <p>Theo dõi lịch mới, xác nhận kết quả, tính điểm và các thay đổi liên quan đến đội.</p>
        </div>
        <div className="d-flex gap-2 flex-wrap">
          <Button
            variant={showUnreadOnly ? "primary" : "outline-primary"}
            onClick={() => setShowUnreadOnly((value) => !value)}
          >
            Chưa đọc
          </Button>
          <Button variant="outline-secondary" onClick={markAllRead}>
            Đánh dấu đã đọc
          </Button>
        </div>
      </div>

      {error && <Alert variant="warning">{error}</Alert>}

      <Card>
        <ListGroup variant="flush">
          {loading ? (
            <div className="p-4">
              <Spinner animation="border" />
            </div>
          ) : items.length === 0 ? (
            <ListGroup.Item>Không có thông báo.</ListGroup.Item>
          ) : (
            items.map((item) => (
              <ListGroup.Item
                key={item.id}
                className={`notification-row ${item.read_at ? "" : "unread"}`}
              >
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <strong>{item.title}</strong>
                    {!item.read_at && <Badge bg="primary">Mới</Badge>}
                  </div>
                  <p className="mb-1">{item.message}</p>
                  <small className="text-muted">{item.created_at}</small>
                </div>
                {!item.read_at && (
                  <Button variant="outline-primary" size="sm" onClick={() => markRead(item.id)}>
                    Đã đọc
                  </Button>
                )}
              </ListGroup.Item>
            ))
          )}
        </ListGroup>
      </Card>
    </div>
  );
};

export default NotificationInbox;
